/**
 * Trimetric brand mark: swim, bike and run as three bars stepping up a race timeline. The tile
 * and bar colours are fixed brand values (the dark-mode sport hues on graphite), so the mark
 * looks the same in both themes, in the favicon and on the home screen. Keep in sync with
 * apps/web/public/icon.svg. See docs/design-guide.md, "Brand".
 */
export const BRAND_MARK = {
  tile: '#141518',
  swim: '#3899E2',
  bike: '#F2B036',
  run: '#40C786',
} as const
